<template>
  <div v-loading.fullscreen.lock="showLoading">
    <!-- 顶部统计指标卡片 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="font-weight: bold; font-size: 16px;">素材制作统计概览</span>
      </div>
      <div class="box_operation">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-card shadow="always" :body-style="currentMode === 'usage' ? 'background-color: #3eb93b;color: #ffffff; text-align: center; cursor: pointer;' : 'background-color: #e6f7ff;color: #333; text-align: center; cursor: pointer;'" @click.native="handleAvgUsageClick">
              <div style="font-size: 16px; font-weight: bold;">平均每用户使用次数</div>
            </el-card>
          </el-col>

          <el-col :span="8">
            <el-card shadow="always" :body-style="currentMode === 'heat-level' ? 'background-color: #9c27b0;color: #ffffff; text-align: center; cursor: pointer;' : 'background-color: #e6f7ff;color: #333; text-align: center; cursor: pointer;'" @click.native="handleHeatLevelClick">
              <div style="font-size: 16px; font-weight: bold;">受欢迎素材统计</div>
            </el-card>
          </el-col>

          <el-col :span="8">
            <el-card shadow="always" :body-style="currentMode === 'count' ? 'background-color: #1cc88a;color: #ffffff; text-align: center; cursor: pointer;' : 'background-color: #e6f7ff;color: #333; text-align: center; cursor: pointer;'" @click.native="handleTotalMaterialClick">
              <div style="font-size: 16px; font-weight: bold;">素材制作数量</div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <!-- 图表和筛选区域 -->
    <div class="tutorial_box">
      <!-- 筛选操作区域 -->
      <div class="box_operation">
        <div class="input_box">
          <el-select v-model="timeType" placeholder="请选择时间维度" @change="updateTimeType">
            <el-option
              v-for="item in timeTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>

        <div class="input_box">
          <el-select v-model="materialType" placeholder="请选择素材类型" @change="updateMaterialType">
            <el-option
              v-for="item in materialTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>

        <div class="input_box">
          <el-date-picker
            v-model="selectDate"
            type="daterange"
            align="right"
            unlink-panels
            format="yyyy-MM-dd"
            value-format='yyyy-MM-dd'
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="changeDate">
          </el-date-picker>
        </div>

        <div class="btn_box">
          <el-button type="primary" @click="refreshData">刷新数据</el-button>
        </div>
      </div>

      <!-- 图表区域 -->
      <div class="horizontal-container">
        <div class="horizontal-item">
          <h3 class="title_box">{{ getChartTitle() }}</h3>
        </div>
      </div>
      
      <!-- 热度级别说明 -->
      <div v-if="currentMode === 'heat-level'" class="heat-level-info">
        <el-card class="info-card">
          <div slot="header" class="clearfix">
            <span style="font-weight: bold;">热度级别分类标准</span>
            <span style="font-size: 12px; color: #909399; margin-left: 10px;">（点击数值可编辑，回车确认）</span>
            <span style="font-size: 12px; color: #E6A23C; margin-left: 20px; font-weight: bold;">热度注意点：节假日更高，老素材更低</span>
          </div>
          <div class="info-content">
            <div class="info-row">
              <div class="info-item">
                <span class="material-type">贴图素材：</span>
                <span class="heat-range">
                  不太好 &lt; 
                  <input 
                    v-model.number="heatLevels.tietu.poor" 
                    @keyup.enter="updateHeatLevels"
                    class="heat-input"
                    type="number"
                    min="0">
                </span>
                <span class="heat-range">
                  可以 
                  <input 
                    v-model.number="heatLevels.tietu.okay.min" 
                    @keyup.enter="updateHeatLevels"
                    class="heat-input"
                    type="number"
                    min="0">
                  -
                  <input 
                    v-model.number="heatLevels.tietu.okay.max" 
                    @keyup.enter="updateHeatLevels"
                    class="heat-input"
                    type="number"
                    min="0">
                </span>
                <span class="heat-range">
                  好 
                  <input 
                    v-model.number="heatLevels.tietu.good.min" 
                    @keyup.enter="updateHeatLevels"
                    class="heat-input"
                    type="number"
                    min="0">
                  -
                  <input 
                    v-model.number="heatLevels.tietu.good.max" 
                    @keyup.enter="updateHeatLevels"
                    class="heat-input"
                    type="number"
                    min="0">
                </span>
                <span class="heat-range">
                  极好 &gt; 
                  <input 
                    v-model.number="heatLevels.tietu.excellent" 
                    @keyup.enter="updateHeatLevels"
                    class="heat-input"
                    type="number"
                    min="0">
                </span>
              </div>
              <div class="info-item">
                <span class="material-type">模板素材：</span>
                <span class="heat-range">
                  不太好 &lt; 
                  <input 
                    v-model.number="heatLevels.template.poor" 
                    @keyup.enter="updateHeatLevels"
                    class="heat-input"
                    type="number"
                    min="0">
                </span>
                <span class="heat-range">
                  可以 
                  <input 
                    v-model.number="heatLevels.template.okay.min" 
                    @keyup.enter="updateHeatLevels"
                    class="heat-input"
                    type="number"
                    min="0">
                  -
                  <input 
                    v-model.number="heatLevels.template.okay.max" 
                    @keyup.enter="updateHeatLevels"
                    class="heat-input"
                    type="number"
                    min="0">
                </span>
                <span class="heat-range">
                  好 
                  <input 
                    v-model.number="heatLevels.template.good.min" 
                    @keyup.enter="updateHeatLevels"
                    class="heat-input"
                    type="number"
                    min="0">
                  -
                  <input 
                    v-model.number="heatLevels.template.good.max" 
                    @keyup.enter="updateHeatLevels"
                    class="heat-input"
                    type="number"
                    min="0">
                </span>
                <span class="heat-range">
                  极好 &gt; 
                  <input 
                    v-model.number="heatLevels.template.excellent" 
                    @keyup.enter="updateHeatLevels"
                    class="heat-input"
                    type="number"
                    min="0">
                </span>
              </div>
            </div>
          </div>
        </el-card>
      </div>
      
      <!-- 受欢迎素材统计提示 -->
      <div v-if="currentMode === 'heat-level'" class="heat-level-tips">
        <el-alert
          title="热度注意点：节假日更高，老素材更低"
          type="info"
          :closable="false"
          show-icon>
        </el-alert>
      </div>
      
      <div class="echart" id="materialChart" :style="myChartStyle"></div>

      <!-- 详细数据表格 -->
      <div>
        <h3>详细数据</h3>
      </div>
      <div class="data_box">
        <el-table
          class="table"
          border
          ref="multiple"
          :cell-style="tableRowClassName"
          :data="materialStatisticsList"
          height="600">
          <el-table-column
            prop="date"
            width="200"
            align="center"
            label="日期">
          </el-table-column>
          <el-table-column
            prop="type"
            align="center"
            width="200"
            label="素材类型">
          </el-table-column>
          <el-table-column
            v-if="currentMode === 'usage'"
            prop="averageUse"
            align="center"
            label="平均使用次数">
          </el-table-column>
          <el-table-column
            v-if="currentMode === 'count'"
            prop="makeCount"
            align="center"
            label="素材制作数量">
          </el-table-column>
          <el-table-column
            v-if="currentMode === 'heat-level'"
            prop="poorCount"
            align="center"
            label="不太好">
          </el-table-column>
          <el-table-column
            v-if="currentMode === 'heat-level'"
            prop="okayCount"
            align="center"
            label="可以">
          </el-table-column>
          <el-table-column
            v-if="currentMode === 'heat-level'"
            prop="goodCount"
            align="center"
            label="好">
          </el-table-column>
          <el-table-column
            v-if="currentMode === 'heat-level'"
            prop="excellentCount"
            align="center"
            label="极好">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import {dateRangePickerOptionsExcludeToday} from "@/base_js/dateRangePickerOptions";

export default {
  name: "MaterialStatistics",
  data() {
    return {
      showLoading: false,

      // 当前显示模式：usage-平均使用次数，count-素材制作数量，heat-level-热度级别统计
      currentMode: 'usage',

      // 图表相关
      myChart: {},
      xData: [], // 日期
      yData: [], // 数据
      myChartSeries: [], // 图表数据系列

      // 筛选条件
      timeType: "day", // 时间维度，恢复默认为每天
      materialType: "tietu", // 素材类型，修改默认值为"tietu"
      selectDate: [],

      // 筛选选项
      timeTypeList: [
        { id: 0, label: '每天', value: "day" },
        { id: 1, label: '每周', value: "week" },
        { id: 2, label: '每月', value: "month" }
      ],
      materialTypeList: [
        { id: 0, label: '贴图', value: "tietu" },
        { id: 1, label: '模板', value: "template" }
      ],

      pickerOptions: dateRangePickerOptionsExcludeToday,

      // 表格数据
      materialStatisticsList: [],

      // 热度级别数据
      heatLevels: {
        tietu: {
          poor: 3000,
          okay: { min: 3000, max: 6000 },
          good: { min: 6000, max: 9000 },
          excellent: 9000
        },
        template: {
          poor: 2000,
          okay: { min: 2000, max: 4000 },
          good: { min: 4000, max: 6000 },
          excellent: 6000
        }
      },

      // 图例显示状态
      legendSelected: {
        '不太好': false,
        '可以': true,
        '好': true,
        '极好': true
      }
    }
  },

  computed: {
    myChartStyle() {
      return {
        float: "left",
        width: "100%",
        height: this.currentMode === 'heat-level' ? "700px" : "600px"
      };
    }
  },

  mounted() {
    this.$bus.$emit("setMenuActiveIndex", "1-3-1");
    this.setDefaultDate();
    this.loadStatisticsData();
  },

  methods: {
    // 设置默认日期
    setDefaultDate() {
      const end = new Date();
      const start = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24);
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      this.selectDate = [formatDate(start), formatDate(end)];
    },

    // 获取图表标题
    getChartTitle() {
      switch (this.currentMode) {
        case 'usage':
          return '平均使用次数趋势图表';
        case 'count':
          return '素材制作数量趋势图表';
        case 'heat-level':
          return '受欢迎素材分布趋势图表';
        default:
          return '统计图表';
      }
    },

    // 获取共用的xAxis配置
    getXAxisConfig() {
      return {
        type: 'category',
        boundaryGap: false,
        data: this.xData
      };
    },

    // 加载统计数据
    loadStatisticsData() {
      this.showLoading = true;
      
      const params = {
        timeType: this.timeType,
        materialType: this.materialType,
        startDate: this.selectDate[0],
        endDate: this.selectDate[1]
      };
      
      console.log('=== 请求参数 ===');
      console.log('请求参数:', params);
      
      // 调用新的原始数据接口
      this.$request.post('/material/statistics/raw-data', params, {
        headers: {
          "Content-Type": "application/json"
        },
      })
        .then(response => {
          if (response.status === 200) {
            const rawData = response.data || [];
            console.log('后端返回原始数据条数:', rawData.length);
            
            // 根据当前模式处理数据
            if (this.currentMode === 'heat-level') {
              this.materialStatisticsList = this.processHeatLevelData(rawData);
            } else {
              this.materialStatisticsList = this.processStatisticsData(rawData);
            }
            
            console.log('=== 最终统计结果 ===');
            console.log('最终统计结果:', this.materialStatisticsList);
            
            this.initChart();
          } else {
            this.$message.error(response.data || '获取统计数据失败');
          }
          this.showLoading = false;
        })
        .catch(error => {
          this.showLoading = false;
          this.$message.error('加载数据失败');
          console.error('加载素材统计数据失败:', error);
        });
    },

    // 处理统计数据（平均使用次数和制作数量）
    processStatisticsData(rawData) {
      const groupedData = this.groupDataByTime(rawData || []);
      const typeLabel = this.getMaterialTypeLabel();

      // 按筛选区间补齐时间轴，无数据的点显式为 0
      return this.buildTimeKeys().map(timeKey => {
        const items = groupedData[timeKey] || [];
        let value = 0;
        if (this.currentMode === 'usage') {
          const totalHotness = items.reduce((sum, item) => sum + (item.hotness || 0), 0);
          value = items.length > 0 ? totalHotness / items.length : 0;
        } else if (this.currentMode === 'count') {
          value = items.length;
        }

        return {
          date: timeKey,
          type: typeLabel,
          averageUse: this.currentMode === 'usage' ? Math.round(value * 10) / 10 : undefined,
          makeCount: this.currentMode === 'count' ? value : undefined
        };
      });
    },

    // 处理热度级别数据
    processHeatLevelData(rawData) {
      const groupedData = this.groupDataByTime(rawData || []);
      const levels = this.getCurrentHeatLevels();
      const typeLabel = this.getMaterialTypeLabel();

      return this.buildTimeKeys().map(timeKey => {
        const items = groupedData[timeKey] || [];
        let poorCount = 0;
        let okayCount = 0;
        let goodCount = 0;
        let excellentCount = 0;

        items.forEach(item => {
          const hotness = item.hotness || 0;
          if (hotness < levels.poor) {
            poorCount++;
          } else if (hotness >= levels.okay.min && hotness < levels.okay.max) {
            okayCount++;
          } else if (hotness >= levels.good.min && hotness < levels.good.max) {
            goodCount++;
          } else if (hotness > levels.excellent) {
            excellentCount++;
          }
        });

        return {
          date: timeKey,
          type: typeLabel,
          poorCount,
          okayCount,
          goodCount,
          excellentCount
        };
      });
    },

    // 按筛选起止日期生成完整时间轴（含数量为 0 的点）
    buildTimeKeys() {
      if (!this.selectDate || this.selectDate.length !== 2) {
        return [];
      }

      const start = this.parseCreateTime(this.selectDate[0]);
      const end = this.parseCreateTime(this.selectDate[1]);
      if (isNaN(start.getTime()) || isNaN(end.getTime()) || start > end) {
        return [];
      }

      const keys = [];
      const cursor = new Date(start.getFullYear(), start.getMonth(), start.getDate());

      if (this.timeType === 'week') {
        while (cursor <= end) {
          const key = this.getWeekRange(cursor);
          if (keys[keys.length - 1] !== key) {
            keys.push(key);
          }
          cursor.setDate(cursor.getDate() + 7);
        }
        const endKey = this.getWeekRange(end);
        if (keys[keys.length - 1] !== endKey) {
          keys.push(endKey);
        }
        return keys;
      }

      if (this.timeType === 'month') {
        cursor.setDate(1);
        const endMonth = new Date(end.getFullYear(), end.getMonth(), 1);
        while (cursor <= endMonth) {
          const month = String(cursor.getMonth() + 1).padStart(2, '0');
          keys.push(`${cursor.getFullYear()}-${month}`);
          cursor.setMonth(cursor.getMonth() + 1);
        }
        return keys;
      }

      while (cursor <= end) {
        keys.push(this.formatDate(cursor));
        cursor.setDate(cursor.getDate() + 1);
      }
      return keys;
    },

    // 按时间维度分组数据
    groupDataByTime(rawData) {
      const grouped = {};
      
      console.log('=== 时间分组调试信息 ===');
      console.log('原始数据条数:', rawData.length);
      console.log('时间维度:', this.timeType);
      console.log('原始数据前5条:', rawData.slice(0, 5));
      
      rawData.forEach((item, index) => {
        // 取库内日历日，避免 new Date('yyyy-MM-dd HH:mm:ss') 在部分环境下偏一天
        const date = this.parseCreateTime(item.createTime);
        let timeKey;

        if (this.timeType === 'day') {
          timeKey = this.formatDate(date);
        } else if (this.timeType === 'week') {
          timeKey = this.getWeekRange(date);
        } else if (this.timeType === 'month') {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          timeKey = `${year}-${month}`;
        }

        if (!grouped[timeKey]) {
          grouped[timeKey] = [];
        }
        grouped[timeKey].push(item);
        
        // 输出前10条的分组信息
        if (index < 10) {
          console.log(`第${index + 1}条: 创建时间=${item.createTime}, 分组键=${timeKey}`);
        }
      });

      console.log('分组结果:', Object.keys(grouped).map(key => `${key}: ${grouped[key].length}条`));
      console.log('=== 时间分组调试信息结束 ===');
      
      return grouped;
    },

    // 获取周范围
    getWeekRange(date) {
      const startOfWeek = new Date(date);
      const day = startOfWeek.getDay();
      const diff = startOfWeek.getDate() - day + (day === 0 ? -6 : 1); // 调整为周一开始
      startOfWeek.setDate(diff);
      
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      
      const result = `${this.formatDate(startOfWeek)}到${this.formatDate(endOfWeek)}`;
      
      // 调试信息
      console.log(`周范围计算: 输入日期=${this.formatDate(date)}, 星期=${day}, 周范围=${result}`);
      
      return result;
    },

    // 获取当前素材类型的热度级别阈值
    getCurrentHeatLevels() {
      if (this.materialType === 'tietu') {
        return this.heatLevels.tietu;
      } else if (this.materialType === 'template') {
        return this.heatLevels.template;
      } else {
        // 默认使用贴图的阈值
        return this.heatLevels.tietu;
      }
    },

    // 获取素材类型标签
    getMaterialTypeLabel() {
      const typeMap = {
        'all': '全部',
        'tietu': '贴图',
        'template': '模板',
        'meme': '表情包',
        'audio': '音频'
      };
      return typeMap[this.materialType] || '全部';
    },

    // 格式化日期
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    // 按库内日期解析创建时间，避免时区把日历日挪偏
    parseCreateTime(createTime) {
      if (typeof createTime === 'string' && /^\d{4}-\d{2}-\d{2}/.test(createTime)) {
        const [year, month, day] = createTime.slice(0, 10).split('-').map(Number);
        return new Date(year, month - 1, day);
      }
      return new Date(createTime);
    },

    // 初始化图表
    initChart() {
      this.xData = [];
      this.yData = [];
      this.myChartSeries = [];

      if (this.currentMode === 'heat-level') {
        this.initHeatLevelChart();
      } else {
        this.initRegularChart();
      }
    },

    // 初始化热度级别图表
    initHeatLevelChart() {
      // 处理日期数据
      this.xData = this.materialStatisticsList.map(item => item.date);
      
      // 准备多条折线数据
      const poorData = this.materialStatisticsList.map(item => item.poorCount || 0);
      const okayData = this.materialStatisticsList.map(item => item.okayCount || 0);
      const goodData = this.materialStatisticsList.map(item => item.goodCount || 0);
      const excellentData = this.materialStatisticsList.map(item => item.excellentCount || 0);
      
      // 构建图表系列数据
      this.myChartSeries = [
        {
          name: '不太好',
          type: 'line',
          data: poorData,
          smooth: true,
          lineStyle: { color: '#ff6b6b' },
          itemStyle: { color: '#ff6b6b' },
          symbol: 'circle',
          symbolSize: 6
        },
        {
          name: '可以',
          type: 'line',
          data: okayData,
          smooth: true,
          lineStyle: { color: '#ffa726' },
          itemStyle: { color: '#ffa726' },
          symbol: 'circle',
          symbolSize: 6
        },
        {
          name: '好',
          type: 'line',
          data: goodData,
          smooth: true,
          lineStyle: { color: '#66bb6a' },
          itemStyle: { color: '#66bb6a' },
          symbol: 'circle',
          symbolSize: 6
        },
        {
          name: '极好',
          type: 'line',
          data: excellentData,
          smooth: true,
          lineStyle: { color: '#42a5f5' },
          itemStyle: { color: '#42a5f5' },
          symbol: 'circle',
          symbolSize: 6
        }
      ];

      this.drawHeatLevelChart();
    },

    // 初始化常规图表
    initRegularChart() {
      // 处理数据
      this.materialStatisticsList.forEach(item => {
        this.xData.push(item.date);
        if (this.currentMode === 'usage') {
          this.yData.push(item.averageUse || 0);
        } else {
          this.yData.push(item.makeCount || 0);
        }
      });

      // 构建图表配置
      const seriesName = this.currentMode === 'usage' ? '平均使用次数' : '素材制作数量';
      const yAxisName = this.currentMode === 'usage' ? '平均使用次数' : '素材制作数量';
      
      this.myChartSeries = [{
        name: seriesName,
        type: 'line',
        data: this.yData,
        smooth: true,
        lineStyle: {
          color: this.currentMode === 'usage' ? '#409EFF' : '#1cc88a'
        },
        itemStyle: {
          color: this.currentMode === 'usage' ? '#409EFF' : '#1cc88a'
        },
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: this.currentMode === 'usage' ? [
              { offset: 0, color: 'rgba(64, 158, 255, 0.3)' },
              { offset: 1, color: 'rgba(64, 158, 255, 0.1)' }
            ] : [
              { offset: 0, color: 'rgba(28, 200, 138, 0.3)' },
              { offset: 1, color: 'rgba(28, 200, 138, 0.1)' }
            ]
          }
        }
      }];

      this.drawChart(yAxisName);
    },

    // 绘制热度级别图表
    drawHeatLevelChart() {
      const materialTypeLabel = this.getMaterialTypeLabel();
      let heatLevels;
      
      if (this.materialType === 'tietu') {
        const levels = this.heatLevels.tietu;
        heatLevels = `不太好(<${levels.poor}) | 可以(${levels.okay.min}-${levels.okay.max}) | 好(${levels.good.min}-${levels.good.max}) | 极好(>${levels.excellent})`;
      } else if (this.materialType === 'template') {
        const levels = this.heatLevels.template;
        heatLevels = `不太好(<${levels.poor}) | 可以(${levels.okay.min}-${levels.okay.max}) | 好(${levels.good.min}-${levels.good.max}) | 极好(>${levels.excellent})`;
      } else {
        heatLevels = '不同素材类型有不同热度标准';
      }
      
      const option = {
        title: {
          text: `${materialTypeLabel}受欢迎素材分布趋势`,
          left: 'center',
          top: '1%',
          textStyle: {
            fontSize: 14,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          formatter: function(params) {
            let tooltipText = `${params[0].name}<br/>`;
            params.forEach(param => {
              tooltipText += `${param.marker}${param.seriesName}: ${param.value}<br/>`;
            });
            return tooltipText;
          }
        },
        legend: {
          data: ['不太好', '可以', '好', '极好'],
          top: '5%',
          left: 'center',
          selected: this.legendSelected
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '10%',
          containLabel: true
        },
        xAxis: this.getXAxisConfig(),
        yAxis: {
          type: 'value',
          name: '数量',
          scale: true,
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLabel: {
            formatter: '{value}'
          }
        },
        series: this.myChartSeries
      };

      const chartDom = document.getElementById('materialChart');
      const existingChart = echarts.getInstanceByDom(chartDom);
      
      if (existingChart) {
        existingChart.dispose();
      }
      
      this.myChart = echarts.init(chartDom);
      this.myChart.setOption(option);
      
      // 监听图例选择事件
      this.myChart.on('legendselectchanged', (params) => {
        this.legendSelected = { ...params.selected };
      });
      
      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },

    // 绘制图表
    drawChart(yAxisName) {
      const title = this.currentMode === 'usage' ? '素材平均使用次数趋势' : '素材制作数量趋势';
      
      const option = {
        title: {
          text: title,
          left: 'center'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: this.getXAxisConfig(),
        yAxis: {
          type: 'value',
          name: yAxisName
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          formatter: function(params) {
            if (params && params.length > 0) {
              return `${params[0].name}<br/>${yAxisName}: ${params[0].value}`;
            }
          }
        },
        series: this.myChartSeries
      };

      const chartDom = document.getElementById('materialChart');
      const existingChart = echarts.getInstanceByDom(chartDom);
      
      if (existingChart) {
        existingChart.dispose();
      }
      
      this.myChart = echarts.init(chartDom);
      this.myChart.setOption(option);
      
      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },

    // 事件处理方法
    updateTimeType() {
      this.loadStatisticsData();
    },

    updateMaterialType() {
      this.loadStatisticsData();
    },

    changeDate() {
      this.loadStatisticsData();
    },

    refreshData() {
      this.loadStatisticsData();
    },

    tableRowClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        return 'background: #FFF8DC;';
      } else if (columnIndex === 2) {
        return 'background: #f0f9eb;';
      }
      return '';
    },

    handleAvgUsageClick() {
      if (this.currentMode !== 'usage') {
        this.currentMode = 'usage';
        this.loadStatisticsData();
        this.$message.success('已切换到平均每用户使用次数模式');
      }
    },

    handleHeatLevelClick() {
      if (this.currentMode !== 'heat-level') {
        this.currentMode = 'heat-level';
        this.timeType = 'week'; // 热度级别统计默认为每周
        this.loadStatisticsData();
        this.$message.success('已切换到受欢迎素材统计模式');
      }
    },

    handleTotalMaterialClick() {
      if (this.currentMode !== 'count') {
        this.currentMode = 'count';
        this.loadStatisticsData();
        this.$message.success('已切换到素材制作数量模式');
      }
    },

    // 更新热度级别数据
    updateHeatLevels() {
      // 验证数值的合理性
      const validateLevels = (levels, type) => {
        if (levels.poor <= 0 || levels.excellent <= 0) {
          this.$message.error(`${type}素材的热度阈值必须大于0`);
          return false;
        }
        if (levels.okay.min >= levels.okay.max) {
          this.$message.error(`${type}素材的"可以"级别最小值必须小于最大值`);
          return false;
        }
        if (levels.good.min >= levels.good.max) {
          this.$message.error(`${type}素材的"好"级别最小值必须小于最大值`);
          return false;
        }
        if (levels.poor >= levels.okay.min) {
          this.$message.error(`${type}素材的热度级别阈值设置不合理，请检查数值大小关系`);
          return false;
        }
        return true;
      };

      // 验证贴图和模板的阈值设置
      if (!validateLevels(this.heatLevels.tietu, '贴图') || 
          !validateLevels(this.heatLevels.template, '模板')) {
        return;
      }

      this.$message.success('热度级别标准已更新');
      this.loadStatisticsData();
    }
  }
}
</script>

<style scoped>
.tutorial_box {
  width: 100%;
  margin-top: 10px;
  background: white;
  min-height: 100%;
  border-radius: 5px;
  padding: 15px 20px;
}

.box_operation {
  width: 100%;
  padding: 15px 0;
}

.horizontal-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.horizontal-item {
  margin-right: 20px;
}

.title_box {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.input_box {
  display: inline-block;
  margin: 0 10px;
  margin-top: 10px;
}

.btn_box {
  margin-top: 10px;
  height: 40px;
  margin-left: 20px;
  vertical-align: top;
  display: inline-block;
}

.data_box {
  width: 100%;
}

.page {
  width: 100%;
  margin-top: 20px;
  text-align: center;
}

.echart {
  margin-bottom: 20px;
}

.box-card {
  margin-bottom: 10px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.data_box /deep/ .el-table .warning-row {
  background: oldlace;
}

.data_box /deep/ .el-table .success-row {
  background: #f0f9eb;
}

.heat-level-info {
  margin-bottom: 4px;
}

.info-card {
  background-color: #fff;
  border-radius: 4px;
  padding: 4px;
}

.info-content {
  margin-top: 2px;
}

.info-row {
  margin-bottom: 2px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.info-item {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.material-type {
  font-weight: bold;
  color: #303133;
  min-width: 80px;
  display: inline-block;
}

.info-item .el-tag {
  margin-right: 8px;
}

.heat-range {
  margin: 0 8px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.heat-input {
  width: 80px;
  height: 32px;
  padding: 6px 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  background-color: #fff;
  transition: border-color 0.2s;
  appearance: none;
  -moz-appearance: textfield;
}

.heat-input::-webkit-outer-spin-button,
.heat-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.heat-input:focus {
  outline: none;
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.heat-input:hover {
  border-color: #c0c4cc;
}

.heat-level-tips {
  margin-bottom: 10px;
}
</style> 